import React, { Fragment, useState } from 'react';

import Modal from './ui/Modal';
import { getDataByID } from '../functions';
import { useTranslation } from 'react-i18next';

export default function ElementDisplay(props) {
    const { t } = useTranslation();
    // const [selectedStyleIndex, setSelectedStyleIndex] = useState(1);

    // const openModal = () => setModalVisible(true);
    // const closeModal = () => setModalVisible(false);

    function addModule(forceDirection) {
        if (props.selElement?.code) {
            const dir = forceDirection || props.modDirection.direction
            props.setPopup(false)
            props.iframe.addPart(props.selElement.code, dir);
            props.setSelElement()
        }
    }
    // console.log(props.modDirection)
    return (
        <div className="flex flex-col items-center justify-center my-auto w-full h-full relative">
            {/* ---------------------------- Element Display ------------------------------ */}


            {/* -------------------- Modal ------------------------ */}
            <Modal isVisible={props.popup} onClose={() => props.setPopup(false)}>
                {/* ------------------ Modal Header ---------------------- */}
                <div className='mx-auto'>
                    <h2 className="md:text-[32px] text-[25px] font-bold mx-auto text-center">{t("addNew")}</h2>
                    <p className="text-black mb-4 text-xl text-center">
                        {t("chooseStyle")}
                    </p>
                </div>
                {/* --------------- Modal Container ----------------------- */}
                <div className='flex-1 h-full mx-auto my-12 p-1 grid grid-cols-2 md:grid-cols-4 overflow-y-auto gap-[5px] items-center justify-center'>
                    {
                        props.allModels.filter(e => props.modDirection?.modules.includes(e.code)).map((val, index) => {
                            const dirArray = props.modDirection.isInit && (val.code === "one arm" || val.code === "corner") ? ["left", "right"] : [props.modDirection.direction];
                            return (
                                dirArray.map((vDir, iDir) => {
                                    const newVal = {...val}
                                    const dir = vDir;
                                    const goodID = val.id + "_" + dir;
                                    newVal.direction = dir;
                                    newVal.clickedID = goodID;
                                    // console.log(val.clickedID)
                                    return (
                                        <Fragment key={index + "_" + iDir}>
                                            {newVal.type === "mod" && <div className={`p-4 md:p-0 flex flex-col h-auto box-content border border-black cursor-pointer relative ${props.selElement?.clickedID === goodID ? "border-4 border-black" : "hover:border-2 hover:border-gray-400"}`}>
                                                <img src={`./images/thumbnails/${props.collection.code?.replace(/\s/g, "_")}/${newVal.code?.replace(/\s/g, "_")}.jpg`} className={`${dir === "right" && "-scale-x-100"}`} alt={newVal.code} onClick={() => { props.setSelElement(newVal);}} />
                                                {goodID === props.selElement?.clickedID && <p className='lowercase absolute w-full bottom-[17px] left-1/2 -translate-x-1/2 font-bold text-[14px] text-center'>{t("customWord", { fr: newVal.name.fr, en: newVal.name.en })}</p>}
                                                {/* {val.id === props.selElement.id && <div className='absolute w-full-plus-8 h-full-plus-8 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 border-4 border-black z-10'></div>} */}
                                            </div>}
                                        </Fragment>
                                    )
                                })
                            )
                        })
                    }
                </div>

                {/* ----------------- Close Button -------------------- */}
                <div className='w-[calc(100%-32px)] md:w-full flex flex-row gap-8 bottom-8 fixed md:relative'>
                    <button
                        onClick={() => props.setPopup(false)}
                        className="bg-[#666] transition-colors text-white text-xl lowercase px-[20px] py-[10px] hover:bg-[black] w-full"
                    >
                        {t("close")}
                    </button>
                    <button
                        onClick={() => addModule(props.selElement?.direction)}
                        className={`bg-[#666] transition-colors text-white text-xl lowercase px-[20px] py-[10px] ${props.selElement?.code ? "hover:bg-[black]" : "opacity-30"} w-full`}
                        disabled={!props.selElement?.code}
                    >
                        {t("add")}
                    </button>
                </div>
            </Modal>
        </div>
    );
}
